export const SECTION_ANALYTICS_EVENTS = {
  jobPostCreated: "section job post created",
  changeRequestApproved: "section change request approved",
  changeRequestRejected: "section change request rejected",
  changeRequestUpdated: "section change request updated",
  changeRequestReassigned: "section change request reassigned"
} as const;

export type SectionAnalyticsSource = "section_jobs" | "section_change_requests";

export type SectionAnalyticsData = {
  source: SectionAnalyticsSource;
  success: boolean;
  sectionId?: string;
  targetSectionId?: string;
  jobPostId?: string;
  changeRequestId?: string;
  changeType?: string;
  action?: string;
  field?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
  hasMessage?: boolean;
  createsFollowUpTask?: boolean;
};

export function getSectionAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: SectionAnalyticsSource;
  success?: boolean;
} & Omit<SectionAnalyticsData, "source" | "success">): SectionAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
